import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import api from "../lib/api";
import { FALLBACK_CONTENT } from "../lib/fallback";
import Header from "../components/landing/Header";
import MarqueeBand from "../components/landing/MarqueeBand";
import Footer from "../components/landing/Footer";
import ExitIntentPopup from "../components/landing/ExitIntentPopup";
import { effectivePawColor, pawStyle } from "../lib/paws";
import { activeHoliday } from "../lib/holidays";

export default function SiteLayout() {
  const [content, setContent] = useState(FALLBACK_CONTENT);
  const { pathname, hash } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent((c) => ({ ...c, ...r.data }))).catch(() => {});
  }, []);

  useEffect(() => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const lenis = new Lenis({ duration: 1.05, smoothWheel: !reducedMotion });
    lenisRef.current = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (hash) {
      let tries = 0;
      const tick = () => {
        const el = document.querySelector(hash);
        if (el) {
          lenisRef.current?.resize();
          lenisRef.current?.scrollTo(el, { offset: -90 });
        } else if (tries++ < 12) setTimeout(tick, 90);
      };
      const t = setTimeout(tick, 90);
      return () => clearTimeout(t);
    }
    lenisRef.current?.scrollTo(0, { immediate: true });
    return undefined;
  }, [pathname, hash]);

  return (
    <div
      className="landing-page min-h-screen bg-white text-stone-900 antialiased"
      style={pawStyle(content.settings)}
      data-testid="landing-page-root"
      data-paw-intensity={content.settings.pawIntensity ?? 50}
      data-paw-color={effectivePawColor(content.settings)}
      data-holiday={activeHoliday(content.settings)?.id || "off"}
    >
      <Header settings={content.settings} />
      <MarqueeBand />
      <main>
        <Outlet context={content} />
      </main>
      <Footer settings={content.settings} />
      <ExitIntentPopup settings={content.settings} />
    </div>
  );
}
